import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import type { InterpolationValues, Translation } from '@/feature/lang/types';
import { Icon } from '@/icon/Icon';
import type { IconName } from '@/icon/types';
import { Box } from '../Box';
import Tooltip from '../Tooltip';
import Translate from '../Translate';

type HelpProps = {
  icon?: IconName;
  visible?: boolean;
  margin?: 'none' | 'small';
  // Show help text in tooltip
  tooltip?: boolean;
} & (
  | { text: Translation; values?: InterpolationValues; children?: never }
  | { children: ReactNode; text?: never; values?: never; tooltip?: never }
);

function HelpText({
  text,
  values,
  children,
  icon = 'info',
  visible = true,
  margin = 'small',
  tooltip = false,
}: HelpProps) {
  const marginValue = margin === 'small' ? 1 : 0;
  const content =
    children ?? (text && <Translate text={text} values={values} />);

  if (!visible || !content) {
    return null;
  }

  if (tooltip && text) {
    return (
      <Box m={marginValue} height="20px">
        <Tooltip title={text} values={values}>
          <Icon name={icon} size="small" color="primary" cursor="default" />
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box display="flex" m={marginValue} alignItems="flex-start">
      <Icon name={icon} size="small" color="primary" />
      <Typography
        variant="body2"
        component="div"
        sx={{
          ml: 1,
          mt: '1px',
        }}
      >
        {content}
      </Typography>
    </Box>
  );
}

export default HelpText;
